// Function To Update SelectedFieldOrder
export function modifyDownloadFieldsArray(
  selectedFieldOrder: string[],
  categoryFields: {value: string; active: boolean}[]
): string[] {

  const updatedFieldOrder = [...selectedFieldOrder]
  for(const field of categoryFields){
    const idx = updatedFieldOrder.indexOf(field.value)

    if(field.active && idx === -1){
      updatedFieldOrder.push(field.value);
    }

    if(!field.active && idx !== -1){
      updatedFieldOrder.splice(idx,1);
    }
  }
  return updatedFieldOrder;
}
